import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PartnerBrandingState } from "./partner-branding.reducer";

export const selectPartnerBrandingState = createFeatureSelector<PartnerBrandingState>("partnerBranding");

export const getPartnerAbbreviation = createSelector(
  selectPartnerBrandingState,
  (state: PartnerBrandingState) => state.abbreviation
);

export const getPartnerBranding = createSelector(
  selectPartnerBrandingState,
  (state: PartnerBrandingState) => state.branding
);

/** True only on a spoke subdomain — every hub hostname keeps today's behavior. */
export const isPartnerSpoke = createSelector(
  selectPartnerBrandingState,
  (state: PartnerBrandingState) => !!state.abbreviation
);
